import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HeadersInterceptorService implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes('assets/images')) {
      req = req.clone({ headers: req.headers.set('Accept', 'image/*') });
    } else {
      req = req.clone({
        headers: req.headers.set('Accept', 'application/json'),
      });
    }

    return next.handle(req);
  }

  constructor() {}
}
